<div class="site-page-header-ghost-wrapper">
  <nz-page-header [nzGhost]="false">
    <nz-page-header-title class="ml4">Coupons</nz-page-header-title>
    <nz-page-header-extra class="mr4">
      <button
        nz-button
        nzType="primary"
        [routerLink]="['add']"
        [queryParams]="{ index: index }"
        routerLinkActive="router-link-active"
        class="submitoraddbutton"
      >
        Add Coupon
      </button>
    </nz-page-header-extra>
  </nz-page-header>
</div>
<div nz-row nzJustify="end" class="mt4">
  <div nz-col nzLg="6" nzMd="6" nzSm="24" nzXs="24">
    <nz-form-label nzFor="Date">Filter by Date</nz-form-label>
    <nz-form-item>
      <nz-form-control [nzSpan]="24" nzErrorTip="Please select a Date!">
        <nz-range-picker
          class="width-100"
          [(ngModel)]="dateRange"
          (ngModelChange)="onChangeDateRange($event)"
        ></nz-range-picker>
      </nz-form-control>
    </nz-form-item>
  </div>
  <div nz-col nzLg="8" nzMd="8" nzSm="24" nzXs="24" class="mb5 ml3">
    <nz-form-label nzFor="chapter"> Search</nz-form-label>
    <nz-input-group [nzSuffix]="suffixIconSearch">
      <input
        type="text"
        nz-input
        placeholder="Search by Coupon name or Code"
        ngModel
        (ngModelChange)="searchCouponByNameCode($event)"
      />
    </nz-input-group>
    <ng-template #suffixIconSearch>
      <i nz-icon nzType="search"></i>
    </ng-template>
  </div>
</div>

<nz-tabset
  (nzSelectedIndexChange)="changeIndex($event)"
  [nzSelectedIndex]="index"
>
  <nz-tab nzTitle="Approved Coupons">
    <nz-table
      #storyTbl
      [nzData]="allApprovedCoupons"
      [nzLoading]="loading"
      [nzTotal]="totalApprovedDataCount"
      [(nzPageSize)]="pageSize"
      [nzPageIndex]="pageIndex"
      [nzFrontPagination]="false"
      (nzQueryParams)="onQueryParamsChange($event)"
      nzShowSizeChanger
      [nzScroll]="{ x: '900px' }"
    >
      <thead>
        <tr>
          <th>Title</th>
          <th>Code</th>
          <th>Discount</th>
          <th>Date</th>
          <th nzWidth="90px">Status</th>
          <th class="text-right" nzWidth="150px">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of allApprovedCoupons; index as i">
          <td>
            <span
              *ngIf="data.couponTitle"
              class="{{ data.couponTitle ? 'ellipsis' : '' }}"
            >
              {{ data.couponTitle }}
            </span>
          </td>
          <td>
            <nz-tag [nzColor]="'#87d068'">{{ data.couponCode }}</nz-tag>
          </td>
          <td>
            <span *ngIf="data.discountType === 'FLAT'">Rs.</span
            >{{ data.discountValue
            }}<span *ngIf="data.discountType === 'PERCENTAGE'"
              >% - Max. Rs.{{ data.maxDiscountValue }}</span
            >
          </td>
          <td>
            {{ data.startDate | date : "mediumDate" }} -
            {{ data.endDate | date : "mediumDate" }}
          </td>
          <td>
            <span
              class="{{ data.status ? 'active' : 'inactive' }} status"
            ></span>
          </td>
          <td class="action-buttons">
            <a
              nz-button
              nzTooltipTitle="Edit"
              nzTooltipPlacement="topCenter"
              nz-tooltip
              [routerLink]="['update', data._id]"
              [queryParams]="{ index: index }"
              routerLinkActive="router-link-active"
              ><i nz-icon nzType="form" nzTheme="outline"></i
            ></a>

            <a
              *ngIf="userRole !== 'subAdmin'"
              class="action-button"
              nz-button
              nz-popconfirm
              nzPopconfirmTitle="Are you sure {{
                data.status ? 'de-active' : 'active'
              }} this?"
              (nzOnConfirm)="updateStatus(data._id, data.status)"
              nzTooltipTitle="{{ data.status ? 'Deactive' : 'Active' }}"
              nzTooltipPlacement="topRight"
              nz-tooltip
              ><i
                nz-icon
                [nzType]="data.status ? 'stop' : 'check'"
                nzTheme="outline"
              ></i
            ></a>

            <a
              *ngIf="userRole !== 'subAdmin'"
              class="action-button delete"
              nz-button
              nz-popconfirm
              nzPopconfirmTitle="Are you sure delete this ?"
              (nzOnConfirm)="deleteCoupon(data._id)"
              z
              ><i nz-icon nzType="delete" nzTheme="fill"></i
            ></a>

            <a
              class="action-button"
              nz-button
              [nzType]="'default'"
              nzTooltipTitle="Analytics"
              (click)="openAnalytics(data._id)"
              nzTooltipPlacement="topRight"
              nz-tooltip
              ><i nz-icon nzType="eye" nzTheme="outline"></i
            ></a>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </nz-tab>

  <nz-tab nzTitle="Un-approved Coupons">
    <nz-table
      #storyTbl
      [nzData]="allCoupons"
      [nzLoading]="loading"
      [nzTotal]="totalDataCount"
      [(nzPageSize)]="pageSize"
      [nzPageIndex]="pageIndex"
      [nzFrontPagination]="false"
      (nzQueryParams)="onQueryParamsChange($event)"
      nzShowSizeChanger
      [nzScroll]="{ x: '900px' }"
    >
      <thead>
        <tr>
          <th>Title</th>
          <th>Code</th>
          <th>Discount</th>
          <th>Date</th>
          <th nzWidth="100px">Created By</th>
          <th nzWidth="200px" *ngIf="userRole === 'subAdmin'">
            Rejected Reason
          </th>
          <th nzWidth="90px">Status</th>
          <th class="text-right" nzWidth="150px">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of allCoupons; index as i">
          <td>
            <span
              *ngIf="data.couponTitle"
              class="{{ data.couponTitle ? 'ellipsis' : '' }}"
            >
              {{ data.couponTitle }}
            </span>
          </td>
          <td>
            <p>
              <nz-tag [nzColor]="'#87d068'">{{ data.couponCode }}</nz-tag>
            </p>
          </td>
          <td>
            <span *ngIf="data.discountType === 'FLAT'">Rs.</span
            >{{ data.discountValue
            }}<span *ngIf="data.discountType === 'PERCENTAGE'"
              >% - Max. Rs.{{ data.maxDiscountValue }}</span
            >
          </td>
          <td>
            {{ data.startDate | date : "mediumDate" }} -
            {{ data.endDate | date : "mediumDate" }}
          </td>
          <td>
            <span *ngIf="data.createdBy?.role === 'subAdmin'">
              {{ data?.createdBy?.name }}
            </span>
          </td>
          <td *ngIf="userRole === 'subAdmin'">
            <span *ngIf="data.rejectionReason" class="ellipsis">{{
              data.rejectionReason
            }}</span>
          </td>
          <td>
            <span
              class="{{ data.status ? 'active' : 'inactive' }} status"
            ></span>
            <p style="margin-top: 10px">
              <nz-tag
                [nzColor]="
                  data.approveStatus === 'approved'
                    ? 'green'
                    : data.approveStatus === 'pending'
                    ? 'lime'
                    : 'volcano'
                "
              >
                {{ data.approveStatus }}
              </nz-tag>
            </p>
          </td>
          <td class="action-buttons">
            <a
              nz-button
              nzTooltipTitle="Edit"
              nzTooltipPlacement="topCenter"
              nz-tooltip
              [routerLink]="['update', data._id]"
              [queryParams]="{ index: index }"
              routerLinkActive="router-link-active"
              ><i nz-icon nzType="form" nzTheme="outline"></i
            ></a>

            <a
              *ngIf="userRole !== 'subAdmin'"
              class="action-button"
              nz-button
              nz-popconfirm
              nzPopconfirmTitle="Are you sure {{
                data.status ? 'deActive' : 'active'
              }} this"
              (nzOnConfirm)="updateStatus(data._id, data.status)"
              nzTooltipTitle="{{ data.status ? 'Deactive' : 'Active' }}"
              nzTooltipPlacement="topRight"
              nz-tooltip
              ><i
                nz-icon
                [nzType]="data.status ? 'stop' : 'check'"
                nzTheme="outline"
              ></i
            ></a>

            <a
              *ngIf="userRole !== 'subAdmin'"
              class="action-button top-margin"
              nz-button
              nz-popconfirm
              nzPopconfirmTitle="Are you sure Approved this?"
              (nzOnConfirm)="updatePendingStatus(data._id, data.approveStatus)"
              nzTooltipTitle="{{ 'Approve' }}"
              nzTooltipPlacement="topRight"
              nz-tooltip
              ><i nz-icon nzType="file-done" nzTheme="outline"></i
            ></a>

            <a
              *ngIf="
                userRole !== 'subAdmin' && data.approveStatus !== 'rejected'
              "
              class="action-button top-margin delete"
              nz-button
              nz-popconfirm
              nzPopconfirmTitle="Are you sure Reject this?"
              (nzOnConfirm)="openRejectionReason(data._id, data.approveStatus)"
              nzTooltipTitle="Reject"
              nzTooltipPlacement="topRight"
              nz-tooltip
              ><i nz-icon [nzType]="'close-circle'" nzTheme="fill"></i
            ></a>
            <a
              *ngIf="userRole !== 'subAdmin'"
              class="action-button delete"
              nz-button
              nz-popconfirm
              nzPopconfirmTitle="Are you sure delete this ?"
              (nzOnConfirm)="deleteCoupon(data._id)"
              z
              ><i nz-icon nzType="delete" nzTheme="fill"></i
            ></a>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </nz-tab>

  <nz-tab nzTitle="Expired Coupons">
    <nz-table
      [nzData]="expiredCoupons"
      [nzLoading]="loading"
      [nzTotal]="totalExpiredDataCount"
      [(nzPageSize)]="pageSize"
      [nzPageIndex]="pageIndex"
      [nzFrontPagination]="false"
      (nzQueryParams)="onQueryParamsChange($event)"
      nzShowSizeChanger
      [nzScroll]="{ x: '900px' }"
    >
      <thead>
        <tr>
          <th>Title</th>
          <th>Code</th>
          <th>Discount</th>
          <th>Date</th>
          <th nzWidth="90px">Status</th>
          <th class="text-right" nzWidth="150px">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of expiredCoupons; index as i">
          <td>
            <span *ngIf="data.couponTitle" class="ellipsis">
              {{ data.couponTitle }}
            </span>
          </td>
          <td>
            <nz-tag [nzColor]="'#f84f4f'">{{ data.couponCode }}</nz-tag>
          </td>
          <td>
            <span *ngIf="data.discountType === 'FLAT'">Rs.</span
            >{{ data.discountValue
            }}<span *ngIf="data.discountType === 'PERCENTAGE'"
              >% - Max. Rs.{{ data.maxDiscountValue }}</span
            >
          </td>
          <td>
            {{ data.startDate | date : "mediumDate" }} -
            {{ data.endDate | date : "mediumDate" }}
          </td>
          <td>
            <span class="inactive status"></span>
          </td>
          <td class="action-buttons">
            <a
              nz-button
              nzTooltipTitle="View"
              nzTooltipPlacement="topCenter"
              nz-tooltip
              (click)="openAnalytics(data._id)"
              ><i nz-icon nzType="eye" nzTheme="outline"></i
            ></a>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </nz-tab>
</nz-tabset>
